import { defineMessages } from 'react-intl';

export default defineMessages({
    standardizingAddressMessage: {
        id: 'rewrite.eh.views.eh-policydetails-details.Standardizing address...',
        defaultMessage: 'Standardizing address...'
    },
    loadingNextPageMessage: {
        id: 'rewrite.eh.views.eh-policydetails-details.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    creatingYourSubmissionMessage: {
        id: 'rewrite.eh.views.eh-policydetails-details.Creating your submission...',
        defaultMessage: 'Creating your submission...'
    },
    ehPriorAddressTitle: {
        id: 'rewrite.eh.views.eh-priorAddress-details.priorAddress',
        defaultMessage: 'Prior Address'
    },
    ehPriorAddressTitleNumber: {
        id: 'rewrite.eh.views.eh-priorAddress-details.priorAddress Number:',
        defaultMessage: 'Prior Address:'
    },
    ehPriorAddress: {
        id: 'rewrite.eh.quote.Homeowners priorAddress',
        defaultMessage: 'Prior Address'
    },
    removePriorAddressTitle: {
        id: 'rewrite.eh.controllers.EHpriorAddressDetailsCtrl.Remove priorAddress?',
        defaultMessage: 'Remove Prior Address?'
    },
    removePriorAddressDescription: {
        id: 'rewrite.eh.drivers.remove-priorAddress.message',
        defaultMessage: 'Are you sure you want to remove this Prior Address from the list of Prior Addresses?'
    },
    ehAddAnotherPriorAddressTitle: {
        id: 'rewrite.eh.views.eh-priorAddress-details.Add Another priorAddress?',
        defaultMessage: 'Add Another Prior Address?'
    },
    ehAddPriorAddressButtonText: {
        id: 'rewrite.eh.views.eh-priorAddress-details.Add priorAddress',
        defaultMessage: 'Add Prior Address'
    },
    ehPriorAddressToggleButton: {
        id: 'rewrite.eh.views.eh-priorAddress-details.Lived one Year',
        defaultMessage: 'Lived there more than one year?'
    },
    ehAddAnotherPriorAddress: {
        id: 'rewrite.eh.views.eh-priorAddress-details.Add another address',
        defaultMessage: 'Add Prior Address'
    },
    ehOptional: {
        id: 'rewrite.eh.views.eh-policydetails-details.optional',
        defaultMessage: 'Optional'
    },
    locationCode: {
        id: 'rewrite.eh.views.eh-policydetails-details.Location Code',
        defaultMessage: 'Location Code'
    },
    ehAgencyInformation: {
        id: 'rewrite.eh.views.eh-policydetails-details.Agency Information',
        defaultMessage: 'Agency Information'
    },
    newHomePurchase: {
        id: 'rewrite.eh.quick.views.policyDetails.New Home Purchase',
        defaultMessage: 'Is this quote for a new home purchase?'
    },
    newHomePurchaseYes: {
        id: 'rewrite.eh.quick.views.policyDetails.New Home Purchase.Yes',
        defaultMessage: 'Yes'
    },
    newHomePurchaseNo: {
        id: 'rewrite.eh.quick.views.policyDetails.New Home Purchase.No',
        defaultMessage: 'No'
    },
    currentInsuranceForProperty: {
        id: 'rewrite.eh.quick.views.policyDetails.Do you Currently have insurance on this Property?',
        defaultMessage: 'Do you Currently have insurance on this Property?'
    },
    currentInsuranceForPropertyYes: {
        id: 'rewrite.eh.quick.views.policyDetails.Do you Currently have insurance on this Property?.Yes',
        defaultMessage: 'Yes'
    },
    currentInsuranceForPropertyNo: {
        id: 'rewrite.eh.quick.views.policyDetails.Do you Currently have insurance on this Property?.No',
        defaultMessage: 'No'
    },
    lastPolicyExpiration: {
        id: 'rewrite.eh.quick.views.policyDetails.When did your last Policy Expire?',
        defaultMessage: 'When does your current policy expire/When did your last policy expire?'
    },
    currentInsuranceExpire: {
        id: 'rewrite.eh.quick.views.policyDetails.When does your current insurance expire?',
        defaultMessage: 'When does your current insurance expire?'
    },
    insuranceHistory: {
        id: 'rewrite.eh.quick.views.policyDetails.Insurance History',
        defaultMessage: 'Insurance History'
    },
    losses: {
        id: 'rewrite.eh.quick.views.policyDetails.Losses',
        defaultMessage: 'Losses'
    },
    propertyLossesLabel: {
        id: 'rewrite.eh.quick.views.policyDetails.Have you had any Property Losses in the Past 5 year?',
        defaultMessage: 'Have you had any Property Losses in the Past 5 year?'
    },
    propertyLossesYes: {
        id: 'rewrite.eh.quick.views.policyDetails.Have you had any Property Losses in the Past 5 year?.Yes',
        defaultMessage: 'Yes'
    },
    propertyLossesNo: {
        id: 'rewrite.eh.quick.views.policyDetails.Have you had any Property Losses in the Past 5 year?.No',
        defaultMessage: 'No'
    },
    manualPropertyLossesAdd: {
        id: 'rewrite.eh.views.Policy Details.Manual Property Losses.Add Property Losses',
        defaultMessage: 'Add Property Losses'
    },
    accountTypeErrorMessage: {
        id: 'rewrite.eh.quick.views.policyDetails.Account type must be a Company or a Person',
        defaultMessage: 'Account type must be a Company or a Person'
    },
    newAccountCreateErrorMessage: {
        id: 'rewrite.eh.quick.views.policyDetails.Could not create the Account',
        defaultMessage: 'Could not create the Account'
    },
    effectiveDate: {
        id: 'rewrite.eh.views.eh-policy-info.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'rewrite.eh.views.eh-policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'rewrite.eh.views.eh-policy-info.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    riskState: {
        id: 'rewrite.eh.views.eh-policy-info.Risk State',
        defaultMessage: 'Risk State'
    },
    middleName: {
        id: 'rewrite.eh.views.eh-policy-info.M.I.',
        defaultMessage: 'M.I.'
    },
    zipCode: {
        id: 'rewrite.eh.views.eh-policy-info.Zip Code',
        defaultMessage: 'Zip Code'
    },
    sourceOfEntry: {
        id: 'rewrite.eh.views.ea-policydetails-details.Source of Entry',
        defaultMessage: 'Source of Entry'
    },
    policyForm: {
        id: 'rewrite.eh.views.eh-policy-info.Policy Form',
        defaultMessage: 'Policy Form'
    },
    policyInformation: {
        id: 'rewrite.eh.views.eh-policy-info.Policy Information',
        defaultMessage: 'Policy Information'
    },
    lastName: {
        id: 'rewrite.eh.views.eh-policydetails-details.Last Name',
        defaultMessage: 'Last Name'
    },
    email: {
        id: 'rewrite.eh.views.eh-policydetails-details.Email',
        defaultMessage: 'Email'
    },
    newPurchaseWithin180Days: {
        id: 'rewrite.eh.quick.views.policyDetails.New purchase within 180 days',
        defaultMessage: 'New purchase within 180 days'
    },
    selfDeclaredPropertyLossesTitle: {
        id: 'rewrite.eh.quick.views.insuredPage.Self Declared Property Losses',
        defaultMessage: 'Self Declared Property Losses'
    },
    locationCodeHelpText: {
        id: 'rewrite.eh.insuredDetailsPage.mailingAndBillingAddress.Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.',
        defaultMessage: 'Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.'
    }
});
